// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Lift waypoint overlay item.
 */
export class Waypoint implements flatbuffers.IUnpackableObject<WaypointT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Waypoint {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsWaypoint(bb: flatbuffers.ByteBuffer, obj?: Waypoint): Waypoint {
    return (obj || new Waypoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsWaypoint(bb: flatbuffers.ByteBuffer, obj?: Waypoint): Waypoint {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Waypoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  nickname(): string | null;
  nickname(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  nickname(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  x(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  y(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  backgroundColorHex(): string | null;
  backgroundColorHex(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  backgroundColorHex(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  backgroundOpacity(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  backgroundWidth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  backgroundHeight(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  displayName(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  fontSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  fontColorHex(): string | null;
  fontColorHex(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fontColorHex(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  backgroundRotationDeg(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  iconRotationDeg(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  nameRotationDeg(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  syncRotations(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  iconWidth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  iconHeight(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  maintainIconAspectRatio(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  linkedLift(): string | null;
  linkedLift(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  linkedLift(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startWaypoint(builder: flatbuffers.Builder) {
    builder.startObject(19);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addNickname(builder: flatbuffers.Builder, nicknameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nicknameOffset, 0);
  }

  static addX(builder: flatbuffers.Builder, x: number) {
    builder.addFieldFloat64(2, x, 0.0);
  }

  static addY(builder: flatbuffers.Builder, y: number) {
    builder.addFieldFloat64(3, y, 0.0);
  }

  static addBackgroundColorHex(
    builder: flatbuffers.Builder,
    backgroundColorHexOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, backgroundColorHexOffset, 0);
  }

  static addBackgroundOpacity(builder: flatbuffers.Builder, backgroundOpacity: number) {
    builder.addFieldInt32(5, backgroundOpacity, 0);
  }

  static addBackgroundWidth(builder: flatbuffers.Builder, backgroundWidth: number) {
    builder.addFieldInt32(6, backgroundWidth, 0);
  }

  static addBackgroundHeight(builder: flatbuffers.Builder, backgroundHeight: number) {
    builder.addFieldInt32(7, backgroundHeight, 0);
  }

  static addDisplayName(builder: flatbuffers.Builder, displayName: boolean) {
    builder.addFieldInt8(8, +displayName, +false);
  }

  static addFontSize(builder: flatbuffers.Builder, fontSize: number) {
    builder.addFieldInt32(9, fontSize, 0);
  }

  static addFontColorHex(builder: flatbuffers.Builder, fontColorHexOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, fontColorHexOffset, 0);
  }

  static addBackgroundRotationDeg(builder: flatbuffers.Builder, backgroundRotationDeg: number) {
    builder.addFieldInt32(11, backgroundRotationDeg, 0);
  }

  static addIconRotationDeg(builder: flatbuffers.Builder, iconRotationDeg: number) {
    builder.addFieldInt32(12, iconRotationDeg, 0);
  }

  static addNameRotationDeg(builder: flatbuffers.Builder, nameRotationDeg: number) {
    builder.addFieldInt32(13, nameRotationDeg, 0);
  }

  static addSyncRotations(builder: flatbuffers.Builder, syncRotations: boolean) {
    builder.addFieldInt8(14, +syncRotations, +true);
  }

  static addIconWidth(builder: flatbuffers.Builder, iconWidth: number) {
    builder.addFieldInt32(15, iconWidth, 0);
  }

  static addIconHeight(builder: flatbuffers.Builder, iconHeight: number) {
    builder.addFieldInt32(16, iconHeight, 0);
  }

  static addMaintainIconAspectRatio(
    builder: flatbuffers.Builder,
    maintainIconAspectRatio: boolean,
  ) {
    builder.addFieldInt8(17, +maintainIconAspectRatio, +true);
  }

  static addLinkedLift(builder: flatbuffers.Builder, linkedLiftOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, linkedLiftOffset, 0);
  }

  static endWaypoint(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createWaypoint(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nicknameOffset: flatbuffers.Offset,
    x: number,
    y: number,
    backgroundColorHexOffset: flatbuffers.Offset,
    backgroundOpacity: number,
    backgroundWidth: number,
    backgroundHeight: number,
    displayName: boolean,
    fontSize: number,
    fontColorHexOffset: flatbuffers.Offset,
    backgroundRotationDeg: number,
    iconRotationDeg: number,
    nameRotationDeg: number,
    syncRotations: boolean,
    iconWidth: number,
    iconHeight: number,
    maintainIconAspectRatio: boolean,
    linkedLiftOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Waypoint.startWaypoint(builder);
    Waypoint.addId(builder, idOffset);
    Waypoint.addNickname(builder, nicknameOffset);
    Waypoint.addX(builder, x);
    Waypoint.addY(builder, y);
    Waypoint.addBackgroundColorHex(builder, backgroundColorHexOffset);
    Waypoint.addBackgroundOpacity(builder, backgroundOpacity);
    Waypoint.addBackgroundWidth(builder, backgroundWidth);
    Waypoint.addBackgroundHeight(builder, backgroundHeight);
    Waypoint.addDisplayName(builder, displayName);
    Waypoint.addFontSize(builder, fontSize);
    Waypoint.addFontColorHex(builder, fontColorHexOffset);
    Waypoint.addBackgroundRotationDeg(builder, backgroundRotationDeg);
    Waypoint.addIconRotationDeg(builder, iconRotationDeg);
    Waypoint.addNameRotationDeg(builder, nameRotationDeg);
    Waypoint.addSyncRotations(builder, syncRotations);
    Waypoint.addIconWidth(builder, iconWidth);
    Waypoint.addIconHeight(builder, iconHeight);
    Waypoint.addMaintainIconAspectRatio(builder, maintainIconAspectRatio);
    Waypoint.addLinkedLift(builder, linkedLiftOffset);
    return Waypoint.endWaypoint(builder);
  }

  unpack(): WaypointT {
    return new WaypointT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.nickname(),
      this.x(),
      this.y(),
      this.backgroundColorHex(),
      this.backgroundOpacity(),
      this.backgroundWidth(),
      this.backgroundHeight(),
      this.displayName(),
      this.fontSize(),
      this.fontColorHex(),
      this.backgroundRotationDeg(),
      this.iconRotationDeg(),
      this.nameRotationDeg(),
      this.syncRotations(),
      this.iconWidth(),
      this.iconHeight(),
      this.maintainIconAspectRatio(),
      this.linkedLift(),
    );
  }

  unpackTo(_o: WaypointT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.nickname = this.nickname();
    _o.x = this.x();
    _o.y = this.y();
    _o.backgroundColorHex = this.backgroundColorHex();
    _o.backgroundOpacity = this.backgroundOpacity();
    _o.backgroundWidth = this.backgroundWidth();
    _o.backgroundHeight = this.backgroundHeight();
    _o.displayName = this.displayName();
    _o.fontSize = this.fontSize();
    _o.fontColorHex = this.fontColorHex();
    _o.backgroundRotationDeg = this.backgroundRotationDeg();
    _o.iconRotationDeg = this.iconRotationDeg();
    _o.nameRotationDeg = this.nameRotationDeg();
    _o.syncRotations = this.syncRotations();
    _o.iconWidth = this.iconWidth();
    _o.iconHeight = this.iconHeight();
    _o.maintainIconAspectRatio = this.maintainIconAspectRatio();
    _o.linkedLift = this.linkedLift();
  }

  unpackFields(...fields: string[]): WaypointT {
    const t = new WaypointT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("nickname")) {
      t.nickname = this.nickname();
    }
    if (fieldSet.has("x")) {
      t.x = this.x();
    }
    if (fieldSet.has("y")) {
      t.y = this.y();
    }
    if (fieldSet.has("background_color_hex")) {
      t.backgroundColorHex = this.backgroundColorHex();
    }
    if (fieldSet.has("background_opacity")) {
      t.backgroundOpacity = this.backgroundOpacity();
    }
    if (fieldSet.has("background_width")) {
      t.backgroundWidth = this.backgroundWidth();
    }
    if (fieldSet.has("background_height")) {
      t.backgroundHeight = this.backgroundHeight();
    }
    if (fieldSet.has("display_name")) {
      t.displayName = this.displayName();
    }
    if (fieldSet.has("font_size")) {
      t.fontSize = this.fontSize();
    }
    if (fieldSet.has("font_color_hex")) {
      t.fontColorHex = this.fontColorHex();
    }
    if (fieldSet.has("background_rotation_deg")) {
      t.backgroundRotationDeg = this.backgroundRotationDeg();
    }
    if (fieldSet.has("icon_rotation_deg")) {
      t.iconRotationDeg = this.iconRotationDeg();
    }
    if (fieldSet.has("name_rotation_deg")) {
      t.nameRotationDeg = this.nameRotationDeg();
    }
    if (fieldSet.has("sync_rotations")) {
      t.syncRotations = this.syncRotations();
    }
    if (fieldSet.has("icon_width")) {
      t.iconWidth = this.iconWidth();
    }
    if (fieldSet.has("icon_height")) {
      t.iconHeight = this.iconHeight();
    }
    if (fieldSet.has("maintain_icon_aspect_ratio")) {
      t.maintainIconAspectRatio = this.maintainIconAspectRatio();
    }
    if (fieldSet.has("linked_lift")) {
      t.linkedLift = this.linkedLift();
    }
    return t;
  }
}

export class WaypointT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public nickname: string | Uint8Array | null = null,
    public x: number = 0.0,
    public y: number = 0.0,
    public backgroundColorHex: string | Uint8Array | null = null,
    public backgroundOpacity: number = 0,
    public backgroundWidth: number = 0,
    public backgroundHeight: number = 0,
    public displayName: boolean = false,
    public fontSize: number = 0,
    public fontColorHex: string | Uint8Array | null = null,
    public backgroundRotationDeg: number = 0,
    public iconRotationDeg: number = 0,
    public nameRotationDeg: number = 0,
    public syncRotations: boolean = true,
    public iconWidth: number = 0,
    public iconHeight: number = 0,
    public maintainIconAspectRatio: boolean = true,
    public linkedLift: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const nickname = this.nickname !== null ? builder.createString(this.nickname!) : 0;
    const backgroundColorHex =
      this.backgroundColorHex !== null ? builder.createString(this.backgroundColorHex!) : 0;
    const fontColorHex = this.fontColorHex !== null ? builder.createString(this.fontColorHex!) : 0;
    const linkedLift = this.linkedLift !== null ? builder.createString(this.linkedLift!) : 0;

    return Waypoint.createWaypoint(
      builder,
      id,
      nickname,
      this.x,
      this.y,
      backgroundColorHex,
      this.backgroundOpacity,
      this.backgroundWidth,
      this.backgroundHeight,
      this.displayName,
      this.fontSize,
      fontColorHex,
      this.backgroundRotationDeg,
      this.iconRotationDeg,
      this.nameRotationDeg,
      this.syncRotations,
      this.iconWidth,
      this.iconHeight,
      this.maintainIconAspectRatio,
      linkedLift,
    );
  }

  clone(): WaypointT {
    const obj = new WaypointT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.nickname = this.nickname;
    obj.x = this.x;
    obj.y = this.y;
    obj.backgroundColorHex = this.backgroundColorHex;
    obj.backgroundOpacity = this.backgroundOpacity;
    obj.backgroundWidth = this.backgroundWidth;
    obj.backgroundHeight = this.backgroundHeight;
    obj.displayName = this.displayName;
    obj.fontSize = this.fontSize;
    obj.fontColorHex = this.fontColorHex;
    obj.backgroundRotationDeg = this.backgroundRotationDeg;
    obj.iconRotationDeg = this.iconRotationDeg;
    obj.nameRotationDeg = this.nameRotationDeg;
    obj.syncRotations = this.syncRotations;
    obj.iconWidth = this.iconWidth;
    obj.iconHeight = this.iconHeight;
    obj.maintainIconAspectRatio = this.maintainIconAspectRatio;
    obj.linkedLift = this.linkedLift;
    return obj;
  }

  equals(other: WaypointT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.nickname !== other.nickname) return false;
    if (!Object.is(this.x, other.x)) return false;
    if (!Object.is(this.y, other.y)) return false;
    if (this.backgroundColorHex !== other.backgroundColorHex) return false;
    if (this.backgroundOpacity !== other.backgroundOpacity) return false;
    if (this.backgroundWidth !== other.backgroundWidth) return false;
    if (this.backgroundHeight !== other.backgroundHeight) return false;
    if (this.displayName !== other.displayName) return false;
    if (this.fontSize !== other.fontSize) return false;
    if (this.fontColorHex !== other.fontColorHex) return false;
    if (this.backgroundRotationDeg !== other.backgroundRotationDeg) return false;
    if (this.iconRotationDeg !== other.iconRotationDeg) return false;
    if (this.nameRotationDeg !== other.nameRotationDeg) return false;
    if (this.syncRotations !== other.syncRotations) return false;
    if (this.iconWidth !== other.iconWidth) return false;
    if (this.iconHeight !== other.iconHeight) return false;
    if (this.maintainIconAspectRatio !== other.maintainIconAspectRatio) return false;
    if (this.linkedLift !== other.linkedLift) return false;
    return true;
  }
}

export function verifyWaypoint(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 8);
    verifier.checkScalarField(tablePos, 10, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 4);
    verifier.checkScalarField(tablePos, 32, 1);
    verifier.checkScalarField(tablePos, 34, 4);
    verifier.checkScalarField(tablePos, 36, 4);
    verifier.checkScalarField(tablePos, 38, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
